import {trackContactPageEvent } from "../common/events";
import { expressEventListener, expressQuerySelector } from "../common/html";
import createContactForm, { IContactFormSubmitResult, ISubtopicWithSubtopicsResult, ITopicWithSubtopicsResult } from "../components/contact-form";
import { IGetSignedUrl } from "../components/file-upload";
import { CreateAndStartLoginWatcher } from "../components/login-check";
import { CreateLoginRegisterComponents } from "../components/login-register";
import { createGeneralPageEventsAndComponents } from "../components/page-general";
import createParcel, { IOrderDetailsResult } from "../components/parcel";
import { createPopup } from "../components/popup-new";
import { postRequest, postRequestWithoutBody } from "../utils/fetch";

window.addEventListener('DOMContentLoaded', () => {
	createGeneralPageEventsAndComponents();
	CreateLoginRegisterComponents();
	CreateAndStartLoginWatcher();

	const parcelContainerEl = expressQuerySelector<HTMLElement>(document, ".technical-split-panel", true);
	const contactFormContainerEl = expressQuerySelector<HTMLElement>(document, ".technical-content-container", false);
	const contactFormEl = expressQuerySelector<HTMLElement>(document, ".technical-contact-form", false);
	const contactThankYouEl = expressQuerySelector<HTMLElement>(document, ".technical-contact-thankyou", false);
	const contactInfoEl = expressQuerySelector<HTMLElement>(document, ".technical-contact-information-container", true);
	const googleRecaptchaEnabled = contactFormEl.dataset.recaptchaenabled === "true";
	const useEnterprise = contactFormEl!.dataset.recaptchaenterpriseenabled === "true";
	const getOrderDetails = (email: string, orderNumber: string) => postRequest<{ Email, Ordernumber }, IOrderDetailsResult>("/apicore/ContactApi/ContactOrderDetails", { Email: email, Ordernumber: orderNumber }, { headers: { 'Content-type': 'application/json; charset=utf-8' } });
	const getTopicWithSubtopics = (index: number) => postRequest<{ TopicIndex }, ITopicWithSubtopicsResult>("/apicore/ContactApi/ContactTopicWithSubtopics", { TopicIndex: index }, { headers: { 'Content-type': 'application/json; charset=utf-8' } });
	const getSubtopic = (topicIndex: number, subtopicIndex: number) => postRequest<{ TopicIndex, SubtopicIndex }, ISubtopicWithSubtopicsResult>("/apicore/ContactApi/ContactSubtopic", { TopicIndex: topicIndex, SubtopicIndex: subtopicIndex }, { headers: { 'Content-type': 'application/json; charset=utf-8' } });
	const getUploadUrl = (sessionId: string, filename: string) => postRequest<{ SessionId, Filename }, IGetSignedUrl>("/apicore/ContactApi/ContactGetUploadUrl", { SessionId: sessionId, Filename: filename }, { headers: { 'Content-type': 'application/json; charset=utf-8' } });
	const getPreventedFileTypes = () => postRequestWithoutBody<string>("/apicore/ContactApi/ContactGetPreventFileTypes", { headers: { 'Content-type': 'application/json; charset=utf-8' } });

	const fetchRecaptchaToken = (): Promise<string> => {
		return new Promise((resolve, _) => {
			const siteKey = contactFormEl!.dataset.sitekey || "";
			const key = contactFormEl!.dataset.key || "";
			if (useEnterprise) {
				grecaptcha.enterprise.execute(key, { action: 'contact_us' })
					.then((token) => {
						resolve(token);
					});
			} else {
				grecaptcha.execute(siteKey, { action: 'contact_us' })
					.then((token) => {
						resolve(token);
					});
			}

		});
	};

	const submitData = (data: { [inputName: string]: string }) => {
		trackContactPageEvent('SendContact');
		const submitContactForm = (token?: string) => {
			return postRequest<any, IContactFormSubmitResult>(
				"/apicore/ContactApi/SubmitContactForm",
				{
					firstname: data['contactfirstname'],
					lastname: data['contactlastname'],
					email: data['contactemail'],
					phone: data['contactphone'],
					ordernr: data['contactordernr'],
					message: data['contactmessage'],
					token: token || '',
					topicIndex: data['topic'],
					subTopicIndex: data['sub_topic'],
					files: data['files']
				},
				{ headers: { 'Content-type': 'application/json; charset=utf-8' } });
		};
		if (googleRecaptchaEnabled) {
			return fetchRecaptchaToken().then(token => {
				return submitContactForm(token);
			});
		} else {
			return submitContactForm();
		}
	};

	const showInformation = (title: string, label: string) => {
		createPopup(
			{
				view: "GenericPopup",
				dialogId: "information",
				forceRefresh: true,
				data:
				{
					TitleLabel: title,
					BodyLabel: label
				}
			})
			.then(popup => popup.openAsync());
	};

	createParcel(
	parcelContainerEl,
		{
			getOrderDetails
		},
	);

	if (contactFormContainerEl && contactFormEl && contactThankYouEl) {
		const createContactFormEl = () => {
			createContactForm(contactFormContainerEl, contactFormEl, contactThankYouEl, {
				getTopicWithSubtopics,
				getSubtopic,
				submitData,
				showInformation,
				getUploadUrl,
				getPreventedFileTypes
			});
		};

		if (googleRecaptchaEnabled) {
			if (useEnterprise) {
				grecaptcha.enterprise.ready(() => {
					createContactFormEl();
				});
			} else {
				grecaptcha.ready(() => {
					createContactFormEl();
				});
			}

		} else {
			createContactFormEl();
		}
	}

	if (contactInfoEl) {
		const phoneLinkEl = expressQuerySelector(contactInfoEl, ".m-contact-tile__telephone-link", false);
		const emailLinkEl = expressQuerySelector(contactInfoEl, ".m-contact-tile__email-link", false);
		const faqLink = expressQuerySelector<HTMLAnchorElement>(contactInfoEl, ".technical-faq-link", false);

		phoneLinkEl && expressEventListener(phoneLinkEl, 'click', (ev: Event) => trackContactPageEvent('PhoneNumberClick'));
		emailLinkEl && expressEventListener(emailLinkEl, 'click', (ev: Event) => trackContactPageEvent('EmailAddressClick'));
		faqLink && expressEventListener(faqLink, 'click', (ev: Event) => trackContactPageEvent('LinkFaq'));
	}
});
